import axios from '../utils/axios';

export default function updateSeekerProfile (adminId, action, data) {
    return axios.post(`/admin/${adminId}/update-seeker/${action}`, data);
}